// SERVICES


// STATE
import DepartmentService from "@/services/department/department.servise";

const state = {
    item: {},
    list: [],
    total: 0,
};

// GETTERS
const getters = {}

// ACTIONS
const actions = {
    async getList({commit}, params) {
        try {
            const res = await DepartmentService.getList( params )
            await commit( 'setListResponse', res );
        } catch (error) {
        }
    },
}

// MUTATIONS
const mutations = {
    setListResponse(state, payload) {
        state.list = payload.data
        state.total = payload.data.length
    },
}

export const department = {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
